<template lang="pug">
div(md-flex='100')
    md-layout.btn-container()
        div
            md-radio(v-model='adBreaksView', md-value='maximizeAds',  @change='maximizeAdsFunction') Recommended
            md-radio(v-model='adBreaksView', md-value='customAds') Custom ads
            md-radio(v-model='adBreaksView', md-value='noAds') Pre-roll only
        md-button.md-icon-button(@click='resetAdBreaks')
            md-icon(md-iconset="fa fa-undo")

    div
        transition-group(
            name='fade',
            enter-active-class='animated fadeIn',
            enter-leave-class='animated fadeOut',
            mode='out-in'
        )

        div(v-show='adBreaksView === "noAds"', key='noAdsView')
        div(md-flex='100', v-show='adBreaksView === "maximizeAds"', key='maximizeAdsView')
            md-button.md-primary.md-raised.btn-ads(v-for='adBreak in recommendedAdBreaks' ref="adBreakButton" :key='adBreak.value' @click='toggleRecommendedAdBreak(adBreak)' v-bind:style="adBreak.checked ? '' : { background: '#eee !important', color: 'black !important'  }") {{adBreak.value === preRollValue ? 'Preroll' : adBreak.value}}
        div(v-show='adBreaksView === "customAds"', key='customAdsView')
            div
                div
                    md-checkbox(v-model='preRollChecked', @change='handlePreRollChange') Add Preroll
                div.inputs
                    div
                        label(for="hour") Hour
                        md-select#hour(placeholder="Hour", v-model="hourForCustomAdbreak") :
                            md-option(v-for="hour in 4", :value="(hour -1).toString().padStart( 2, '0')" :key="hour") {{ (hour -1).toString().padStart( 2, '0') }} 
                    p :
                    div
                        label(for="minute") Minute
                        md-select#minute(placeholder="Minutes", v-model="minuteForCustomAdbreak")
                            md-option( v-for="minute in 60", :value="(minute -1).toString().padStart( 2, '0')" :key="minute") {{ (minute -1).toString().padStart( 2, '0') }} 
                    p :
                    div
                        label(for="second") Second
                        md-select#second(placeholder="Seconds", v-model="secondForCustomAdbreak")
                            md-option( v-for="second in 60", :value="(second -1).toString().padStart( 2, '0')" :key="second") {{ (second -1).toString().padStart( 2, '0') }}
                    md-button.md-primary.md-raised(@click='addCustomAdBreak')
                        md-icon#add-icon-btn(md-iconset="fa fa-plus")
            md-button.md-primary.md-raised.btn-ads(v-for='adBreak in customAdBreaks' ref="customAdBreakButton" @click='deleteCustomAdBreak(adBreak)' :key="adBreak.value") {{adBreak.value === preRollValue ? 'Preroll' : adBreak.value}}
</template>

<script>
    export default {
    components: { },
    props: {
        mediaItem: {
            type: Object,
            required: true,
        },
        formSubmitted: {
            type: Boolean,
            required: true
        }
    },
    data() {
    return {
        adBreaksView: 'maximizeAds',
        recommendedAdBreaks: [],
        customAdBreakValue: '00:00:00',
        preRollValue: '00:00:00',
        customAdBreaks: [],
        hourForCustomAdbreak: '00',
        minuteForCustomAdbreak: '00',
        secondForCustomAdbreak: '00',
        date: '1970-01-01',
        preRollChecked: false,
        resetAds: false
    };
    },
    computed: {
        hasPreRoll() {
            return this.customAdBreaks.some(adBreak => adBreak.value === this.preRollValue);
        }
    },
    methods: {
        showAlert(text,icon, timer){
            this.$swal({
                position: 'top',
                icon: icon,
                text: text,
                timer: !timer ? '4000' : '2000',
                timerProgressBar: true,
                showConfirmButton: false,
        })
        },

        maximizeAdsFunction() {
            const adBreaksJumps = 420;
            const adBreakWindow = this.mediaItem.videoDuration;
            const maxAdBreaks = Math.ceil((adBreakWindow / adBreaksJumps));
            const adBreaksArray = [];
            for (let i = 0; i < maxAdBreaks; i++) {
                adBreaksArray.push(i * adBreaksJumps);
            }

            if (!!this.mediaItem.rokuOptimizedVideoAdBreaks && this.mediaItem.rokuOptimizedVideoAdBreaks.length > 0 && !this.resetAds) {
                this.recommendedAdBreaks = this.mediaItem.rokuOptimizedVideoAdBreaks;
            } else {
                this.recommendedAdBreaks = adBreaksArray.map((adBreak) => {
                    return {value: this.secsToHoursMinsSecs(adBreak), checked: true};
                });
            }
            this.resetAds = false;
        },

        toggleRecommendedAdBreak(option) {
            const idx = this.recommendedAdBreaks.indexOf(option);
            this.recommendedAdBreaks[idx].checked = !option.checked
        },

        deleteCustomAdBreak(option) {
            const idx = this.customAdBreaks.indexOf(option);
            if(option.value === this.preRollValue) {
                this.preRollChecked = false;
            }
            this.customAdBreaks.splice(idx, 1);
        },

        handlePreRollChange() {
            if (!this.preRollChecked) {
                this.addPreRoll();
            } else {
                this.removePreRoll();
            }
        },

        addPreRoll() {
            this.customAdBreaks.unshift({value: this.preRollValue, checked: true});
        },

        removePreRoll() {
            const idx = this.customAdBreaks.findIndex(adBreak => adBreak.value === this.preRollValue);
            if (idx !== -1) {
                this.customAdBreaks.splice(idx, 1);
            }
        },

        addCustomAdBreak() {
            this.customAdBreakValue = `${this.hourForCustomAdbreak}:${this.minuteForCustomAdbreak}:${this.secondForCustomAdbreak}`
            const minMinuteAdBreak = new Date(`${this.date} 00:07:00`);
            const maxMinuteAdBreak =   new Date(`${this.date} ${this.secsToHoursMinsSecs(this.mediaItem.videoDuration)}`);
            const customAdBreakDate = new Date(`${this.date} ${this.customAdBreakValue}`);
            const secsBetweenAdBreaks = 420;
            if (customAdBreakDate >= minMinuteAdBreak && customAdBreakDate <= maxMinuteAdBreak) {
                this.customAdBreaks.push({value: this.customAdBreakValue, checked: true});
            } else {
                this.showAlert('Ad break cannot be in the first 7 minutes of the video or you exceeded the length of the video', 'warning');
                return;
            }

            this.customAdBreaks.sort(( a, b ) => {
                if ( a.value < b.value ){
                    return -1;
                }
                if ( a.value > b.value ){
                    return 1;
                }
                return 0;
            });

            const idx = this.customAdBreaks.map(ad => ad.value).indexOf(this.customAdBreakValue);
            const previousAdBreak = this.customAdBreaks[idx - 1] ? new Date(`${this.date} ${this.customAdBreaks[idx - 1].value}`) : undefined;
            const nextAdBreak = this.customAdBreaks[idx + 1] ? new Date(`${this.date} ${this.customAdBreaks[idx + 1].value}`) : undefined;

            if (!!previousAdBreak) {
                if (((customAdBreakDate - previousAdBreak) / 1000) < secsBetweenAdBreaks) {
                    this.showAlert('Ad break must be at least 7 minutes after the previous ad break', 'warning');
                    this.customAdBreaks.splice(idx, 1);
                    return;
                }
            }

            if (!!nextAdBreak) {
                if (((nextAdBreak - customAdBreakDate) / 1000) < secsBetweenAdBreaks) {
                    this.showAlert('Ad break must be at least 7 minutes before the next ad break', 'warning');
                    this.customAdBreaks.splice(idx, 1);
                    return;
                }
            }
        },

        secsToHoursMinsSecs(secs) {
            const h = (Math.floor(secs / 3600)).toString().padStart(2, '0');
            const m = (Math.floor(secs % 3600 / 60)).toString().padStart(2, '0');
            const s = (Math.floor(secs % 3600 % 60)).toString().padStart(2, '0');
            return `${h}:${m}:${s}`;
        },

        adsInMediaItem() {
            if (!!this.mediaItem.rokuCustomVideoAdBreaks && this.mediaItem.rokuCustomVideoAdBreaks.length > 0) {
                this.customAdBreaks = this.mediaItem.rokuCustomVideoAdBreaks;
            }
            if (this.mediaItem.typeOfRokuVideoAdBreaks === 'maximizeAds') {
                this.adBreaksView = 'maximizeAds';
            }
            if (this.mediaItem.typeOfRokuVideoAdBreaks === 'customAds') {
                this.adBreaksView = 'customAds';
                if (this.mediaItem.rokuCustomVideoAdBreaks.length > 0 && this.mediaItem.rokuCustomVideoAdBreaks[0].value === this.preRollValue) {
                    this.preRollChecked = true;
                }
            }
            if (this.mediaItem.typeOfRokuVideoAdBreaks === 'noAds') {
                this.adBreaksView = 'noAds';
            }
        },

        resetAdBreaks() {
            this.resetAds = true;
            this.maximizeAdsFunction();
            this.customAdBreaks = [];
            this.preRollChecked = false;
        }
    },
    mounted () {
        this.maximizeAdsFunction();
        this.adsInMediaItem();
    },

    watch: {
        formSubmitted: function(submitted) {
            if (submitted) {
                this.mediaItem.typeOfRokuVideoAdBreaks = this.adBreaksView;
                this.mediaItem.rokuOptimizedVideoAdBreaks = this.recommendedAdBreaks;
                this.mediaItem.rokuCustomVideoAdBreaks = this.customAdBreaks;
                this.mediaItem.typeOfRokuVideoAdBreaks = this.adBreaksView;
            }
        },
        mediaItem(){
            this.maximizeAdsFunction();
            this.adsInMediaItem();
        }
    },
    };
</script>

<style lang="scss" scoped>
.md-input-container input {
    height: auto;
}

.inputs{
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 15px;
}

.btn-container{
    justify-content: space-between;
}

.btn-ads{
    max-width: 50px;
    border-radius: 4px;
}

#add-icon-btn{
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItemsRokuAdBreaks.vue